/** @jsxImportSource @emotion/react */
import React from "react";
import { Button } from "antd";
import { SizeType } from "antd/lib/config-provider/SizeContext";
import {
  CloseCircleOutlined,
  EditOutlined,
  SaveOutlined,
} from "@ant-design/icons";

export interface ToolboxEditActionsProps {
  isEditing: boolean;
  onEdit: () => void;
  onCancel: () => void;
  editLabel?: string;
  saveLabel?: string;
  cancelLabel?: string;
  editIcon?: React.ReactNode;
  saveIcon?: React.ReactNode;
  cancelIcon?: React.ReactNode;
  size?: SizeType;
}

export const ToolboxEditActions: React.FC<ToolboxEditActionsProps> = ({
  isEditing,
  onEdit,
  onCancel,
  editLabel = "Edit",
  saveLabel = "Save",
  cancelLabel = "Cancel",
  editIcon = <EditOutlined />,
  saveIcon = <SaveOutlined />,
  cancelIcon = <CloseCircleOutlined />,
  size = "large",
}: ToolboxEditActionsProps) => {
  return (
    <>
      <Button
        size={size}
        onClick={onEdit}
        className={isEditing ? "active" : ""}
        type={isEditing ? "primary" : "default"}
        icon={isEditing ? saveIcon : editIcon}
      >
        {isEditing ? saveLabel : editLabel}
      </Button>
      {isEditing ? (
        <Button size={size} onClick={onCancel} icon={cancelIcon}>
          {cancelLabel}
        </Button>
      ) : null}
    </>
  );
};
